import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Inbox } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Textarea } from "../../components/ui/textarea";
import { PageHeader, Card, EmptyState, Loading } from "../../components/common";
import { api, errMsg } from "../../lib/api";
import { fmtDateTime } from "../../lib/format";

function Ticket({ t, reload }) {
  const [reply, setReply] = useState(t.reply || "");
  const send = async () => {
    try { await api.post(`/admin/support/${t.id}/reply`, { reply, status: "resolved" }); toast.success("Reply sent (in-app)"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card className="p-5" data-testid={`admin-ticket-${t.id}`}>
      <div className="flex flex-wrap justify-between gap-2"><p className="font-semibold">{t.subject}</p><span className={`text-xs font-semibold ${t.status === "resolved" ? "text-emerald-700" : "text-amber-700"}`}>{t.status}</span></div>
      <p className="text-xs text-slate-500"><span className="font-mono">{t.sales_id}</span> · {t.executive_name} · {fmtDateTime(t.created_at)}</p>
      <p className="mt-2 whitespace-pre-line text-sm text-slate-700">{t.message}</p>
      <Textarea className="mt-3" rows={2} placeholder="Write a reply" value={reply} onChange={(e) => setReply(e.target.value)} data-testid={`ticket-reply-${t.id}`} />
      <Button size="sm" className="mt-2" disabled={reply.trim().length < 2} onClick={send} data-testid={`ticket-send-${t.id}`}>Send reply</Button>
    </Card>
  );
}

export default function SupportInbox() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/support").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div className="max-w-3xl">
      <PageHeader title="Support Inbox" subtitle="Messages from Sales Executives. Replies are delivered as in-app notifications." />
      {!items ? <Loading /> : items.length === 0 ? <EmptyState icon={Inbox} title="No messages" /> : <div className="space-y-4">{items.map((t) => <Ticket key={t.id} t={t} reload={load} />)}</div>}
    </div>
  );
}
